<template>
  <div>
    <div class="ma-1">
      <v-card class="px-3">
        <v-row>
          <v-col class="d-flex justify-space-between">
            <div class="subtitle-2">
              <div>Saldo disponible:</div>
              <div v-if="restaurant.balanceLimit">
                Monto límite: <span class="secondary--text font-weight-bold">${{ restaurant.balanceLimit | toFixNumber(2) | numberWithComma }}</span>
              </div>
            </div>
            <div
              data-cy="amontAvailable"
              v-if="!loading && balance"
              :class="[balance.amountAvailable >= total ? 'primary--text font-weight-bold' : 'red--text font-weight-bold']"
            >
              ${{ balance.amountAvailable | toFixNumber(2) | numberWithComma }}
            </div>
            <loader v-else :size="20" :loading="loading" />
          </v-col>
          <v-divider vertical />
          <v-col class="d-flex justify-space-between">
            <div class="subtitle-2">
              <div>
                Saldo congelado:
              </div>
              <div class="caption">
                <a href="#" @click.prevent="openAmountWithheldDetail">
                  Ver detalle
                </a>
              </div>
            </div>
            <div
              data-cy="amountWithheld"
              class="font-weight-bold"
              v-if="!loading && balance"
            >
              ${{ balance.amountWithheld | toFixNumber(2) | numberWithComma }}
            </div>
            <loader v-else :size="20" :loading="loading" />
          </v-col>
          <v-divider vertical />
          <v-col v-if="balance.manageBalanceIsActive" class="d-flex justify-space-between">
            <div class="subtitle-2">
              <div>
                Saldo de área:
              </div>
            </div>
            <div
              data-cy="amountWithheld"
              :class="[areaAmount >= total ? 'primary--text font-weight-bold' : 'red--text font-weight-bold']"
              v-if="!loading && balance"
            >
            ${{ areaAmount | toFixNumber(2) | numberWithComma }}
            </div>
            <loader v-else :size="20" :loading="loading" />
          </v-col>
          <v-divider v-if="balance.manageBalanceIsActive" vertical />
          <slot />
        </v-row>
      </v-card>
    </div>
    <AmountWithheldDetail ref="amountWithheld" />
  </div>
</template>

<script>
import Balance from '@/models/Balance'
import Loader from '@/components/Loader'
import AmountWithheldDetail from '@/components/sidePanels/AmountWithheldDetail'

export default {
  name: 'BalanceDetail',
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  components: {
    Loader,
    AmountWithheldDetail
  },
  data () {
    let balanceModel = new Balance()

    return {
      balanceModel,
      loading: false,
      balance: {
        manageBalanceIsActive: false
      },
      areaAmount: 0,
      areaPercentage: 0
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    areaId: function () {
      return this.$store.state.area.id || null
    }
  },
  mounted () {
    this.getBalance()
  },
  methods: {
    openAmountWithheldDetail () {
      this.$refs.amountWithheld.open()
    },
    async getBalance () {
      this.loading = true
      try {
        this.balanceModel.set({ restaurant: this.restaurant })
        const response = await this.balanceModel.detail()
        this.balance = response.response.data
        if (this.balance && this.balance.manageBalanceIsActive) {
          const selectedArea = this.balance.managedBalance.filter(balance => balance.areaId === this.areaId)
          if (selectedArea.length > 0) this.areaPercentage = selectedArea[0].percentage
          this.areaAmount = selectedArea[0].amount
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
    }
  }
}
</script>
